import { highlightMatchHelper } from 'src/helpers/highlightMatchHelper';
import { TableCell } from 'src/components/ui/table';
import React, { useCallback } from 'react';
import moment from 'moment';
import { useKBContext } from 'src/provider/KnowledgeBaseProvider';
import { clsx } from 'clsx';
import { FILE_STATE } from 'src/pages/AIKnowledgeBasePage/CurrentKnowledgeBasePage/CurrentKnowledgeBaseConstants';

export const CurrentKnowledgeBaseTableNameCell = ({ item, is }) => {
  const { filteredValue } = useKBContext();

  const renderName = useCallback(() => {
    if (is.zendeskTickets || is.freshdeskTickets) {
      const title = `solved from: ${item?.data?.start_from ? moment(item.data.start_from).format('MM/DD/YYYY') : 'start'}; agents: ${Boolean(item?.data?.agents?.length) ? item.data?.agents?.join(', ') : 'all agents'}; tags: ${Boolean(item?.data?.tags?.length) ? item.data?.tags?.join(', ') : 'all tags'}; groups: ${Boolean(item?.data?.groups?.length) ? item.data?.groups?.join(', ') : 'all groups'}`;

      return (
        <span className="flex flex-col gap-0.5">
          <span className={'whitespace-nowrap text-ellipsis overflow-hidden'}>
            {highlightMatchHelper(item.name, filteredValue)}
          </span>
          <span
            title={title}
            className={
              'text-xs text-ebony_opacity_30 self-start whitespace-nowrap text-ellipsis overflow-hidden w-full'
            }
          >
            {title}
          </span>
        </span>
      );
    }
    if (is.website) {
      return (
        <span className="flex flex-col gap-0.5">
          <span className={'whitespace-nowrap text-ellipsis overflow-hidden'}>
            {highlightMatchHelper(item.name, filteredValue)}
          </span>
          {item.data?.urls && item.data?.urls?.length && (
            <span className="truncate opacity-30">
              {item.data?.urls?.map((url, i) => (
                <React.Fragment key={`${url}-${i}`}>
                  <a
                    className="text-xs underline self-start"
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {highlightMatchHelper(url, filteredValue)}
                  </a>
                  {i < item.data.urls.length - 1 && ', '}
                </React.Fragment>
              ))}
            </span>
          )}
          {(item.url || item.external_file_id) && (
            <a
              className={'text-xs text-ebony_opacity_30 underline self-start'}
              href={item.url || item.external_file_id}
              target={'_blank'}
              rel={'noopener noreferrer'}
            >
              {highlightMatchHelper(item.url || item.external_file_id, filteredValue)}
            </a>
          )}
        </span>
      );
    }

    if (item.url || item.external_file_id) {
      return (
        <span className="flex flex-col gap-0.5">
          <span className={'whitespace-nowrap text-ellipsis overflow-hidden'}>
            {highlightMatchHelper(item.name, filteredValue)}
          </span>
          <span className={'text-xs text-ebony_opacity_30 underline self-start'}>
            {highlightMatchHelper(item.url || item.external_file_id, filteredValue)}
          </span>
        </span>
      );
    }

    if (is.error) {
      return (
        <span className="flex flex-col gap-0.5">
          <span className={'whitespace-nowrap text-ellipsis overflow-hidden'}>
            {highlightMatchHelper(item.name, filteredValue)}
          </span>
          <span className={'text-xs text-[#FF515180] self-start'}>
            {FILE_STATE.UPLOAD_ERROR === item.state && 'file upload failed'}
            {FILE_STATE.DELETE_ERROR === item.state && 'file deletion failed'}
          </span>
        </span>
      );
    }

    return <span className={'text-sm'}>{highlightMatchHelper(item.name, filteredValue)}</span>;
  }, [item, filteredValue]);

  return (
    <TableCell padding={'pr-5 py-1'} className="table-fixed text-start max-w-80">
      <p
        title={item.name}
        className={clsx(
          'font-semibold whitespace-nowrap  hyphens-auto  text-sm truncate',
          is.error ? 'text-delete' : 'text-ebony_opacity_80',
        )}
      >
        {renderName()}
      </p>
    </TableCell>
  );
};
